module.exports = __webpack_public_path__ + "img/acmilan-logo-icon.654561d8.png";